<template>
    <billing-layout>
         <div class="page-breadcrumb">
            <div class="row">
                <div class="col-5 align-self-center">
                    <h4 class="page-title">Reports</h4>
                </div>
                <div class="col-7 align-self-center">
                    <div class="d-flex align-items-center justify-content-end">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                   
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
      
        <div class="container-fluid">
            <div class="row">
            <div class="col-12">
                <div class="card">
                <div class="row">
                  <div class="col-md-3">
                    <div class="card card-body">  
                <div class="list-group list-group-flush">
                    <h4>INVOICES</h4>
                    <router-link :to="{name: 'Reportinvoices'}" class="list-group-item list-group-item-action">Invoices</router-link>

                </div>
                    </div>
                    </div>
                    <div class="col-md-3">
                    <div class="card card-body">  
                <div class="list-group list-group-flush">
                    <h4>ESTIMATES</h4>
                    <router-link :to="{name: 'ReportEstimates'}" class="list-group-item list-group-item-action">Estimates</router-link>
                </div>
                    </div>
                    </div>

                <div class="col-md-3">
                    <div class="card card-body">
                    <div class="list-group list-group-flush">
                        <h4>CUSTOMER</h4>
                        <router-link :to="{name: 'ReportCustomer'}" class="list-group-item list-group-item-action">Customers</router-link>
                    </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card card-body">
                    <div class="list-group list-group-flush">
                        <h4>PAYMENTS RECEIVED</h4>
                        <router-link :to="{name: 'ReportPaymentsReceived'}" class="list-group-item list-group-item-action">Paymens Received</router-link>
                    </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card card-body">
                    <div class="list-group list-group-flush">
                        <h4>RECURRING INVOICES</h4>
                        <router-link :to="{name: 'ReportRecurringInvoices'}" class="list-group-item list-group-item-action">Recurring Invoices</router-link>
                    </div>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="card card-body">
                    <div class="list-group list-group-flush">
                        <h4>PROFIT & LOSS</h4>
                        <router-link :to="{name: 'ProfitandLoss'}" class="list-group-item list-group-item-action">Profit & Loss</router-link>
                    </div>
                    </div>
                </div>
                 <div class="col-md-3">
                    <div class="card card-body">
                    <div class="list-group list-group-flush">
                        <h4>EXPENSES & ACCOUNTS</h4>
                        <router-link :to="{name: 'ExpensesbyAccount'}" class="list-group-item list-group-item-action">Expenses Accounts</router-link>
                    </div>
                    </div>
                </div>
                 <div class="col-md-3">
                    <div class="card card-body">
                    <div class="list-group list-group-flush">
                        <h4>EXPENSES</h4>
                        <router-link :to="{name: 'ExpensesReport'}" class="list-group-item list-group-item-action">Expenses</router-link>
                    </div>
                    </div>
                </div>
                 <div class="col-md-3">
                    <div class="card card-body">
                    <div class="list-group list-group-flush">
                        <h4>TAXES</h4>
                        <router-link :to="{name: 'ReportTaxes'}" class="list-group-item list-group-item-action">Sales Tax Report</router-link>
                    </div>
                    </div>
                </div>
                 <div class="col-md-3">
                    <div class="card card-body">
                    <div class="list-group list-group-flush">
                        <h4>MONEY OUT</h4>
                        <router-link :to="{name: 'SubcontractorReport'}" class="list-group-item list-group-item-action">Subcontractor</router-link>
                        <router-link :to="{name: 'VendorsReport'}" class="list-group-item list-group-item-action">Vendor</router-link>
                    </div>
                    </div>
                </div>
              
               
                    </div>
                </div>
              </div>
            </div>
        </div>


  <modal name="modal-setting" height="auto" @before-close="ClosedModal">
    <div class="card">
    <component :is="SettingBox"></component>
    </div>
</modal>
    </billing-layout>
</template>
<script>
import axios from 'axios'
import Loader from '@/components/shared/Loader'
import BillingLayout from '@/Layouts/Billing/BillingLayout'
import Taxes from '@/components/billing/setting/Taxes.vue';
import Terms from '@/components/billing/setting/Terms.vue';
import StartInvoice from '@/components/billing/setting/StartInvoice.vue';
import StartEstimate from '@/components/billing/setting/StartEstimate.vue';
import EventBus from '@/eventBus';
export default {
     name:'Report',
    components:{
            Loader,
            BillingLayout,
            Terms,
            Taxes,
            StartInvoice,
            StartEstimate
    },
    data() {
        return{
           showModal: false,
           SettingBox : ''
        } 
    },
    mounted(){
    //this.getStates()
    EventBus.$on('UpdateOk', data => {
        this.$modal.hide('modal-setting')
			//this.ModalStatus = 'Login';
    });
    EventBus.$on('UpdateStartInvoice', data => {
        this.$modal.hide('modal-setting')
			//this.ModalStatus = 'Login';
    });
      EventBus.$on('UpdateStartEstimate', data => {
        this.$modal.hide('modal-setting')
			//this.ModalStatus = 'Login';
    });
    },
    methods:{

        ClosedModal(){
            this.SettingBox =''
        },
        getStatesxxx() {
              this.isLoadingCustomers = true
            window.billing.get('states/')
                .then((response) => {
					 console.log(response.data.resultStates)         
                    this.CustomersList = response.data.resultStates;
					this.isLoadingCustomers = false
                }).catch((error) => console.log(error));
        },

        
    },
    watch:{
        SettingBox: function (){
            if(!this.SettingBox ==''){
             this.$modal.show('modal-setting');
            }
        }
    }
};
</script>
<style scope="sass">
i.fas.fa-arrow-left {
    font-size: 13px;
}
</style>
